module.exports = __webpack_public_path__ + "nproperty_icon.svg";